// extracted by mini-css-extract-plugin
export default {"tablehead":"Draft_tablehead__AUwNS","custom-striped-table":"Draft_custom-striped-table__0AGEe"};